import { useCallback, useMemo, useState } from 'react'

/**
 * How many cards are mounted at once.
 *
 * The catalogue is 1,070 toolkits and every card is an MUI surface, so
 * rendering the lot locked the tab up. The user is looking for
 * one app, and search narrows the list long before this limit matters.
 */
export const CARD_PAGE_SIZE = 21

/**
 * A growable window over the filtered cards.
 *
 * @param {object[]} cards Already filtered and ranked.
 * @param {string} resetKey Changes whenever the filter does.
 */
export function useCardWindow(cards, resetKey) {
  const [limit, setLimit] = useState(CARD_PAGE_SIZE)
  const [lastKey, setLastKey] = useState(resetKey)

  // Narrowing a search must not keep showing however far the previous result
  // set had been expanded. Reset during render rather than in an effect, so no
  // frame is painted with the stale window.
  if (lastKey !== resetKey) {
    setLastKey(resetKey)
    setLimit(CARD_PAGE_SIZE)
  }

  const visible = useMemo(() => cards.slice(0, limit), [cards, limit])

  return {
    visible,
    hasMore: cards.length > visible.length,
    showMore: useCallback(() => setLimit((n) => n + CARD_PAGE_SIZE), []),
  }
}
